import {useMemo} from 'react';

import {envIsPublicCloud} from '../../../config';
import {DEFAULT_ONPREM_ORGANIZATION_NAME} from '../../../pages/OrgDashboard/OrgRoles/RolesDashboard';
import {useAccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';
import {type Account, AccountType} from '../../Search/SearchNav/types';

export type AutomationsOrgScope = {
  orgName: string;
  isPersonalAccountOnSaaS: boolean;
};

export function getAutomationsOrgScope(
  selectedAccount: Account | null,
  isPublicCloud: boolean = envIsPublicCloud
): AutomationsOrgScope {
  return {
    orgName: isPublicCloud
      ? (selectedAccount?.name ?? '')
      : DEFAULT_ONPREM_ORGANIZATION_NAME,
    isPersonalAccountOnSaaS:
      isPublicCloud && selectedAccount?.accountType === AccountType.Personal,
  };
}

export function useAutomationsOrgScope(): AutomationsOrgScope {
  const {selectedAccount} = useAccountSelectorContext();

  return useMemo(
    () => getAutomationsOrgScope(selectedAccount),
    [selectedAccount]
  );
}
